import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Walk/Walk.tsx");
